import { DismissibleTag, Tag as CarbonTag } from '@carbon/react';
import { cx } from '../../utils';
import styles from './CdTag.module.scss';

export interface CdTagProps {
  label: string;
  /**
   * `operational` – grey bordered pill (applied filters).
   * `selectable` – light-blue pill used for filter / column options.
   */
  variant?: 'operational' | 'selectable';
  size?: 'sm' | 'md';
  /** Renders a dismiss (×) button. */
  onDismiss?: () => void;
  dismissLabel?: string;
  className?: string;
}

export const CdTag = ({
  label,
  variant = 'operational',
  size = 'sm',
  onDismiss,
  dismissLabel,
  className,
}: CdTagProps) => {
  const classes = cx(styles.tag, styles[variant], className);

  if (onDismiss) {
    return (
      <DismissibleTag
        className={classes}
        size={size}
        text={label}
        dismissTooltipLabel={dismissLabel ?? `Remove ${label}`}
        onClose={onDismiss}
      />
    );
  }

  return (
    <CarbonTag className={classes} size={size}>
      {label}
    </CarbonTag>
  );
};
